"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appConfigHelper = require("../../util/appConfigHelper");
var _fetchHelper = _interopRequireDefault(require("../../util/fetchHelper"));
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
var _returnUrlHelper = _interopRequireDefault(require("../../util/returnUrlHelper"));
var _store = _interopRequireDefault(require("../../redux/store"));
const submitPayment = async (paymentMethod, browserInfo, billingAddress) => {
  const API_URL = (0, _environmentHelper.default)();
  const orderId = parseInt((0, _appConfigHelper.getData)('CLEENG_ORDER_ID') || '0', 10);
  const url = "".concat(API_URL, "/connectors/adyen/initial-payment");
  const {
    publisherConfig: {
      enable3DSRedirectFlow
    }
  } = _store.default.getState();
  try {
    const res = await (0, _fetchHelper.default)(url, {
      method: 'POST',
      body: JSON.stringify({
        orderId,
        paymentMethod,
        browserInfo,
        billingAddress,
        origin: window.location.origin,
        returnUrl: (0, _returnUrlHelper.default)({
          queryParams: {
            orderId
          }
        }),
        enable3DSRedirectFlow
      })
    });
    return res.json();
  } catch (e) {
    return e;
  }
};
var _default = exports.default = submitPayment;